import Files from './Files.vue'

export default Files
